const ColorPlagLevel = {
    'high': 'rgba(255, 0, 0, 0.5)',
    'medium': 'rgba(243, 156, 18, 0.5)',
    'low': 'rgba(254, 241, 96, 0.5)',
    'unknown': 'rgba(139,145,157,0.48)'
}

const ColorPlagIgnored = 'rgba(108, 122, 137, 0.5)'
const ColorPlagUserIgnored = 'rgba(37, 116, 169, 0.2)'

export {ColorPlagLevel, ColorPlagIgnored, ColorPlagUserIgnored}
